export interface Updatable {
  updatedDate: Date;
}

/**
 * Given two arrays, merge them into one, containing only the unique items returned from the
 * callback function.
 */
export function mergeArrays<T>(
  array1: T[],
  array2: T[],
  keyName: string,
  callbackfn: (item1: T, item2: T) => T,
): any[] {
  const hash = {};
  for (const item of array1) {
    if (typeof item[keyName] === 'string') {
      hash[item[keyName]] = item;
    } else {
      hash[JSON.stringify(item[keyName])] = item;
    }
  }

  for (const item of array2) {
    let stringKey = '';
    if (typeof item[keyName] === 'string') {
      stringKey = item[keyName];
    } else {
      stringKey = JSON.stringify(item[keyName]);
    }
    if (!hash[stringKey]) {
      hash[stringKey] = item;
    } else {
      const existingItem = hash[stringKey];
      hash[stringKey] = callbackfn(item, existingItem);
    }
  }
  return Object.keys(hash).map((key) => hash[key]);
}

/**
 * Given two arrays, merge them into one, containing only the newest unique items from each.
 */
export function mergeUpdatedArrays<T extends Updatable>(array1: T[], array2: T[], keyName: string): T[] {
  return mergeArrays(array1, array2, keyName, (item1, item2) => {
    return item1.updatedDate > item2.updatedDate ? item1 : item2;
  });
}
